<template>
    <div class="tw-max-w-sm">
        <l-input-text
            :id="`answer-comment-${question.skill_id}`"
            label=""
            type="textarea"
            :value.sync="form.comment"
            class="tw survey-answer-flow"
            :optional="!question.isRequired"
            :placeholder="$t('surveys.participate.commentPlaceholder')"
            :show-text-format-hint="false"
            data-test-id="survey-input-textarea"
            input-class="survey-response-textarea"
            @input="onSaveAnswer"
            @focus="isTextareaInFocus = true"
            @blur="isTextareaInFocus = false"
        />

        <div
            class="tw-text-right tw-text-indigo-500 tw-mt-2 tw-leading-none"
            :class="{ 'tw-opacity-25': !isTextareaInFocus }"
        >
            <l-keyboard-hint-text :keys="['shift', 'enter']">
                <span slot="postfix"> {{ $t("surveys.participate.toMakeALineBreak") }}</span>
            </l-keyboard-hint-text>
        </div>

        <slot />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LInputText from "@/components/LInputText";
import LKeyboardHintText from "@/components/LKeyboardHintText";

export default {
    components: {
        LInputText,
        LKeyboardHintText,
    },
    props: {
        question: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isTextareaInFocus: false,
            form: {
                comment: "",
            },
        };
    },
    computed: {
        ...mapGetters({
            userAnswers: "surveys/answerSession/userAnswers",
        }),
    },
    created() {
        // prefill form from global state
        if (this.userAnswers?.[this.question?.skill._id]) {
            this.form = { ...this.form, ...this.userAnswers?.[this.question.skill._id] };
        }
    },
    methods: {
        onSaveAnswer() {
            const payload = {
                questionId: this.question.skill._id,
                answer: { ...this.form },
            };

            // validation
            payload.answer.comment = payload.answer.comment?.trim() || "";
            if (!payload.answer.comment) delete payload.answer;

            this.$store.dispatch("surveys/answerSession/setAnswer", { payload });
        },
    },
};
</script>
